import { useState, useRef, Fragment } from 'react'

function BatchFileUploader({ onFilesSelect, isLoading }) {
    const [dragActive, setDragActive] = useState(false);
    const fileInputRef = useRef(null);
    try {

        const handleDrag = (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (e.type === "dragenter" || e.type === "dragover") {
                setDragActive(true);
            } else if (e.type === "dragleave") {
                setDragActive(false);
            }
        };

        const handleDrop = (e) => {
            e.preventDefault();
            e.stopPropagation();
            setDragActive(false);
            
            if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                onFilesSelect(e.dataTransfer.files);
            }
        };

        const handleFileChange = (e) => {
            if (e.target.files && e.target.files.length > 0) {
                onFilesSelect(e.target.files);
                // Reset the input value so the same file can be selected again if needed
                e.target.value = '';
            }
        };

        const handleButtonClick = () => {
            fileInputRef.current.click();
        };

        return (
            <div 
                className={`relative border-2 border-dashed rounded-lg p-8 text-center ${
                    dragActive ? 'border-green-400 bg-green-50' : 'border-gray-300 hover:border-gray-400'
                }`}
                onDragEnter={handleDrag}
                onDragLeave={handleDrag}
                onDragOver={handleDrag}
                onDrop={handleDrop}
                data-name="batch-drop-zone"
            >
                <input
                    type="file"
                    ref={fileInputRef}
                    id="pdf-file"
                    accept=".pdf"
                    onChange={handleFileChange}
                    className="hidden"
                    disabled={isLoading}
                    multiple
                    data-name="file-input"
                />
                <div className="space-y-4">
                    <div className="text-center">
                        <i className="fas fa-file-pdf text-4xl text-green-500 mb-4"></i>
                        <h3 className="text-lg font-medium mb-2">拖放檔案到此處或點擊上傳</h3>
                        <p className="text-sm text-gray-500 mb-4">
                            支援多個 PDF 檔案同時上傳（每個檔案最大 5MB）
                        </p>
                    </div>
                    <button
                        type="button"
                        onClick={handleButtonClick}
                        className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-all inline-flex items-center"
                        disabled={isLoading}
                        data-name="upload-button"
                    >
                        <i className="fas fa-upload mr-2"></i>
                        選擇 PDF 檔案
                    </button>
                </div>
            </div>
        );
    } catch (error) {
        console.error('BatchFileUploader component error:', error);
        reportError(error);
        return null;
    }
}

export default BatchFileUploader;